import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';

import {Constant} from '../../../common/constant';

@Injectable()
export class CompanyLockersService {

    constructor(private http: HttpClient) {
    }

    /**
     * Get list of lockers
     * @param {object} params
     * */
    async fnGetLockers(params?: object): Promise<any> {
        let urlSearchParams = new HttpParams();
        for (const key in params) {
            if (params.hasOwnProperty(key) && params[key]) {
                urlSearchParams = urlSearchParams.append(key, params[key]);
            }
        }
        const qString = urlSearchParams.toString();
        return this.http
            .get(Constant.API_URL + 'api/lockers/lookup' + (qString ? '?' + qString : '')).toPromise();
    }
}
